import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { SelectPhone } from '@airtm/airtm-ui';
import SelectCountryPhoneCodeContainer from './SelectCountryPhoneCodeContainer';

const SelectCountryPhoneCode = function ({
  countryCodePlaceholder = '',
  data,
  invalid = false,
  label = null,
  loading,
  onBlurPhoneNumber = () => null,
  onChangeCountryCode = () => null,
  onChangePhoneNumber = () => null,
  phoneNumber,
  phoneNumberPlaceholder = '55 1234 1234',
}) {
  const [countryCode, setCountryCode] = useState(null);

  const handleChangeCountryCode = (selected) => {
    setCountryCode(selected);
    onChangeCountryCode(selected);
  };

  useEffect(() => {
    if (data.initialOption) {
      handleChangeCountryCode(data.initialOption);
    }
  }, [data.initialOption]);

  return (
    <SelectPhone
      countryCode={countryCode}
      countryCodePlaceholder={countryCodePlaceholder}
      disabled={loading}
      invalid={invalid}
      label={label}
      onBlurPhoneNumber={onBlurPhoneNumber}
      onChangeCountryCode={handleChangeCountryCode}
      onChangePhoneNumber={onChangePhoneNumber}
      options={data.options}
      phoneNumber={phoneNumber}
      phoneNumberPlaceholder={phoneNumberPlaceholder}
    />
  );
};

SelectCountryPhoneCode.propTypes = {
  countryCodePlaceholder: PropTypes.string,
  data: PropTypes.shape({
    initialOption: PropTypes.oneOfType([
      () => null,
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
      }).isRequired,
    ]),
    options: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
      }),
    ).isRequired,
  }).isRequired,
  invalid: PropTypes.bool,
  label: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  onBlurPhoneNumber: PropTypes.func,
  onChangeCountryCode: PropTypes.func,
  onChangePhoneNumber: PropTypes.func,
  phoneNumber: PropTypes.string.isRequired,
  phoneNumberPlaceholder: PropTypes.string,
};

export default SelectCountryPhoneCodeContainer(SelectCountryPhoneCode);
